import { render, staticRenderFns } from "./couponActions.vue?vue&type=template&id=12d5beae&"
import script from "./couponActions.vue?vue&type=script&lang=js&"
export * from "./couponActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports